<template>
    <div>
        <el-table :data="zoneStateList" border size="small" style="width: 751px" >
            <el-table-column prop="zoneId" label="ID" align="center" width="70">
            </el-table-column>

            <el-table-column prop="name" label="名称" align="center" width="120">
            </el-table-column>

            <el-table-column prop="numberOfPlayer" label="人数" align="center" width="80">
            </el-table-column>

            <el-table-column prop="numberOfPlayerOnline" label="在线人数" align="center" width="80">
            </el-table-column>

            <el-table-column prop="numberOfPlayerPay" label="付费人数" align="center" width="80">
            </el-table-column>

            <el-table-column label="付费率(%)" align="center" width="80">
                <template scope="scope">
                    <span>{{ scope.row.numberOfPlayer > 0 ? ((scope.row.numberOfPlayerPay / scope.row.numberOfPlayer) * 100).toFixed(2): 0}}</span>
                </template>
            </el-table-column>

            <el-table-column prop="totalPayAmount" label="付费金额(元)" align="center" width="100">
            </el-table-column>

            <el-table-column label="状态" align="center" width="70">
                <template scope="scope">
                    <span v-if="scope.row.status == 0" class="zone-status-tag zone-status-tag-offline">隐藏</span>
                    <span v-else-if="scope.row.status == 1" class="zone-status-tag zone-status-tag-maintained">维护</span>
                    <span v-else-if="scope.row.status == 2" class="zone-status-tag zone-status-tag-idle">流畅</span>
                    <span v-else-if="scope.row.status == 3" class="zone-status-tag zone-status-tag-full">爆满</span>
                </template>
            </el-table-column>

            <el-table-column prop="isHealth" label="健康" align="center" width="70">
                <template scope="scope">
                    <span v-if="scope.row.isHealth">
                        <i class="el-icon-round" style="
                background-color: rgb(73, 243, 73);
                margin-right: 3px;
                border: 1px solid rgb(27, 4, 14);
              "></i>
                    </span>
                    <span v-else>
                        <i class="el-icon-round" style="
                background-color: rgb(255, 65, 65);
                margin-right: 3px;
                border: 1px solid rgb(27, 4, 14);
              "></i>
                    </span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
const axios = require("axios");

export default {
    data() {
        return {
            zoneStateList: [], // 分区状态列表
        };
    },

    async created() {
        this.loadZoneStateList();
    },

    components: {},

    methods: {
        /**
         * 查询分区状态集合
         */
        async loadZoneStateList() {
            let resData = (
                await axios.post(
                    `${this.$util.getBackendApiBase()}/api/admin/v1/zoneState/get`,
                    {},
                    {
                        headers: {
                            token: this.$bizutil.getLoginUserToken(),
                        },
                    }
                )
            ).data;
            if (resData.code > 0) {
                this.$message.error(resData.message);
                return;
            }

            let listInResponse = resData.data.list || [];

            // 排序（按分区id倒序排列）
            listInResponse.sort((x, y) => {
                return y.zoneId - x.zoneId;
            });

            this.zoneStateList = listInResponse;
        },

        /**
         * 打开排行榜对话框
         * @param {} entry
         */
        openLeaderboardDialog(entry) {
            this.$dialogutil.open("LeaderboardDialog", {
                closedCallback: null,
                data: { zoneId: entry.zoneId },
            });
        },

        /**
         * 打开查询累充最先抵达玩家对话框
         * @param {} entry
         */
        openQueryTheFirstPlayerOfCostXYuanDialog(entry) {
            this.$dialogutil.open("QueryTheFirstPlayerOfCostXYuanDialog", {
                closedCallback: null,
                data: { zoneId: entry.zoneId },
            });
        },
    },
};
</script>


<style lang="scss" scoped>
.zone-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.zone-status-tag-maintained {
  background-color: lightgray;
  border-color: lightgray;
}

.zone-status-tag-idle {
  background-color: chartreuse;
  border-color: chartreuse;
}

.zone-status-tag-full {
  background-color: rgb(243, 159, 159);
  border-color: red;
}

.el-icon-round {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}
</style>